import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import CompareBar from "@/components/CompareBar";
import FeaturedBrands from "@/components/FeaturedBrands";
import BackToTop from "@/components/BackToTop";
import CopyGuard from "@/components/CopyGuard";

export default function PublicLayout({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-[#F8F9FA]">
      <Navbar />
      <main className="flex-1">{children}</main>
      <FeaturedBrands variant="footer" />
      <Footer />
      <CompareBar />
      <BackToTop />
      <CopyGuard />
    </div>
  );
}
